module.exports = __webpack_public_path__ + "static/media/logo.4e9d6af5.svg";